import { observer } from 'mobx-react-lite';
import { InfoMailtipAutomaticReplyMultiple } from './OofMailtip.locstring.json';
import { HideInfobarDetailsButton } from 'owa-locstrings/lib/strings/hideinfobardetailsbutton.locstring.json';
import { ShowInfobarDetailsButton } from 'owa-locstrings/lib/strings/showinfobardetailsbutton.locstring.json';
import loc, { format } from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47750 */
import SingleRecipientAutomaticReplyDetails, {
    RecipientMailtipInfo,
} from './SingleRecipientAutomaticReplyDetails';
import * as React from 'react';
import { InfoBarMessagePart } from 'owa-info-bar-view';

import MultiRecipientMailtip from './MultiRecipientMailtip';
import MultiRecipientAutomaticReplyDetails from './MultiRecipientAutomaticReplyDetails';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import {
    createRemoveAllRecipientsLink,
    createRemoveRecipientLink,
} from '../utils/createRemoveRecipientLinks';
import { MailTipsCategory } from '../datapoints';

export interface OofMailtipProps {
    colorScheme?: ColorScheme;
    onRemove: (recipients: EmailAddressWrapper[]) => void;
    recipientsInfo: RecipientMailtipInfo[];
}

export default observer(function OofMailtip(props: OofMailtipProps) {
    const createSingleRecipientOOFMailtip = () => {
        const recipientInfo: RecipientMailtipInfo = props.recipientsInfo[0];
        return (
            <SingleRecipientAutomaticReplyDetails
                recipientInfo={recipientInfo}
                colorScheme={props.colorScheme}
                removeRecipientActionElement={
                    <InfoBarMessagePart
                        colorScheme={props.colorScheme}
                        messagePart={createRemoveRecipientLink(
                            recipientInfo.recipient,
                            props.onRemove,
                            MailTipsCategory.OutOfOffice
                        )}
                    />
                }
            />
        );
    };
    const createMultiRecipientOOFMailtip = () => {
        const { recipientsInfo, onRemove, colorScheme } = props;
        return (
            <MultiRecipientMailtip
                colorScheme={colorScheme}
                messageInfoElement={
                    <InfoBarMessagePart
                        colorScheme={colorScheme}
                        messagePart={format(
                            loc(InfoMailtipAutomaticReplyMultiple),
                            recipientsInfo.length
                        )}
                    />
                }
                removeAllActionElement={
                    onRemove && (
                        <InfoBarMessagePart
                            colorScheme={colorScheme}
                            messagePart={createRemoveAllRecipientsLink(
                                recipientsInfo.map(recipientInfo => recipientInfo.recipient),
                                onRemove,
                                MailTipsCategory.OutOfOffice
                            )}
                        />
                    )
                }
                showHideDetails={{
                    showDetailsText: loc(ShowInfobarDetailsButton),
                    hideDetailsText: loc(HideInfobarDetailsButton),
                    detailsElement: null,
                }}
                detailsRenderer={() => <MultiRecipientAutomaticReplyDetails {...props} />}
                mailTipsCategory={MailTipsCategory.OutOfOffice}
                recipientCount={recipientsInfo.length}
            />
        );
    };
    const { recipientsInfo } = props;
    if (recipientsInfo.length === 0) {
        return null;
    } else if (recipientsInfo.length === 1) {
        return createSingleRecipientOOFMailtip();
    }
    return createMultiRecipientOOFMailtip();
});
